// extracted by mini-css-extract-plugin
export default {"deletedRowPlaceholder":"deletedRowPlaceholder---EkiTK","deletedRowUndoButton":"deletedRowUndoButton---yhLnM"};